<template>
  <div>
    <h1 class="listing-title font-weight-bold text-h4 font-10 my-2" data-testid="listing-title">
      {{ title }}
    </h1>
    <hr />

    <div class="mt-2">
      <strong>
        <span class="rate">{{ formatCurrency(basePrice, currency, locale) }}</span>
      </strong>
      {{ listingType === 'SHARED_TRANSFER' || listingType === 'JOINING_TOUR' ? ' per person' : ' per group' }}
    </div>
    <hr />

    <p v-if="title.toLowerCase().includes('underground')">
      <span class="font-italic">
        <strong>
          This tour includes entrance ticket for Puerto Princesa Underground River Tour with lunch included.
        </strong>
      </span>
    </p>

    <div class="my-2">
      <v-row>
        <v-chip 
          v-if="isBestSeller"
          prepend-icon="mdi-gold" 
          color="primary" 
          size="small" 
          class="ma-1"
        >
          Bestseller
        </v-chip>
        <v-chip 
          v-if="isBestSeller"
          prepend-icon="mdi-thumb-up" 
          color="primary" 
          size="small" 
          class="ma-1"
        >
          Recommended by Travellers
        </v-chip>
        <v-chip 
          v-for="chip in chips"
          :key="chip.text"
          :color="getChipColor(chip.text)" 
          class="ma-1" 
          size="small"
        >
          {{ chip.text }}
        </v-chip>
        <v-chip 
          prepend-icon="mdi-star" 
          size="small" 
          class="ma-1" 
          color="secondary"
        >
          4.5 ({{ reviewCount }}) Reviews
        </v-chip>
        <v-chip 
          prepend-icon="mdi-clock" 
          size="small" 
          class="ma-1" 
          color="secondary"
        >
          {{ 
            schedules.length === 0
              ? 'Departs Anytime'
              : `Departs ${schedules.length} ${schedules.length > 1 ? 'times' : 'time'} daily`
          }}
        </v-chip>
        <v-chip 
          prepend-icon="mdi-clock-outline" 
          size="small" 
          class="ma-1" 
          color="error"
        >
          {{ duration }} Duration
        </v-chip>
      </v-row>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { formatCurrency } from '~/utils/index';

const props = defineProps({
  title: {
    type: String,
    required: true
  },
  basePrice: {
    type: Number,
    required: true
  },
  currency: {
    type: String,
    required: true
  },
  locale: {
    type: String,
    required: true
  },
  listingType: {
    type: String,
    required: true
  },
  isBestSeller: {
    type: Boolean,
    default: false
  },
  chips: {
    type: Array,
    default: () => []
  },
  reviewCount: {
    type: Number,
    default: 0
  },
  schedules: {
    type: Array,
    default: () => []
  },
  duration: {
    type: String,
    required: true
  }
});

// Function to limit v-chip colors to only 3 options
const getChipColor = (text) => {
  // Define just 3 colors to use for all chips
  const chipType = text.toLowerCase();
  
  if (chipType.includes('popular') || chipType.includes('best') || chipType.includes('recommended')) {
    return 'primary'; // Primary color (blue)
  } else if (chipType.includes('limited') || chipType.includes('last') || chipType.includes('hurry')) {
    return 'error'; // Error color (red)
  } else {
    return 'secondary'; // Secondary color (default to grey/purple)
  }
};
</script>

<style scoped>
.rate {
  font-size: 1.25rem;
  color: #F44336; /* Changed to red */
}
</style> 